import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import deepEqual from 'react-fast-compare';

import DialogComponent from '../../components/DialogComponent/DialogComponent';
import { getJsonPath } from '../../constants/CommonUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import ActionButton from '../../components/ActionButton/ActionButton';
import GenericFilterWithSearch from '../../components/GenericFilterComponent/GenericFilterWithSearch';
import AddBulkItemsTable from './AddBulkItemsTable';
import {
    clearProductsState,
    fetchProductsForPurchaseOrder,
} from '../../redux/modules/addBulkItemsInPurchaseOrder/addBulkItemsInPurchaseOrder-actions';
import initialStates from '../../redux/initialStates';
import { PAGE } from '../../constants/constants';
import {
    ADD_BULK_ITEMS_FILTER_SCHEMA,
} from './AddBulkItemsUtil';

class AddBulkItemsDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            schema: null,
            products: [],
            selectedProducts: [],
        };
    }

    componentDidMount() {
        fetch(getJsonPath('/StockManagement/AddBulkItemsSchemaInPO.json'))
            .then(resp => resp.json())
            .then((json) => {
                this.setState({
                    schema: json,
                });
            })
            .catch((error) => {
                console.error(`There has been a problem with your fetch operation:${error.message}`);
            });

        const {
            addBulkItemsInPurchaseOrder: {
                page, size, filters,
            },
        } = this.props;
        this.fetchProducts(page, size, filters);
        this.updateProductsList(getStringFromObject('addBulkItemsInPurchaseOrder.data', this.props, []));
    }

    componentDidUpdate(prevProps) {
        const prevData = prevProps.addBulkItemsInPurchaseOrder.data;
        const currentData = this.props.addBulkItemsInPurchaseOrder.data;

        if (!deepEqual(prevData, currentData)) {
            this.updateProductsList(currentData);
        }
    }

    componentWillUnmount() {
        this.props.dispatch(clearProductsState());
    }

    fetchProducts = (page, size, filters) => {
        const { dispatch, warehouseId } = this.props;
        dispatch(fetchProductsForPurchaseOrder(page, size, filters, warehouseId));
    }

    updateProductsList(data) {
        this.setState({
            products: data,
        });
    }

    handleRowSelection = (selectedList) => {
        this.setState(prevState =>
            ({
                selectedProducts: {
                    ...prevState.selectedProducts,
                    ...selectedList,
                },
            }),
        );
    };

     handleUpdateSelectedProduct = (updatedData, remove) => {
         this.setState((prevState) => {
             if (remove) {
                 const updatedSelectedProducts = {
                     ...prevState.selectedProducts,
                 };

                 delete updatedSelectedProducts[updatedData.uuid];

                 return {
                     selectedProducts: updatedSelectedProducts,
                 };
             }

             return {
                 selectedProducts: {
                     ...prevState.selectedProducts,
                     [updatedData.uuid]: updatedData,
                 },
             };
         });
     };

    handleSave = () => {
        const { onSave, onClose } = this.props;
        const { selectedProducts } = this.state;
        onSave(selectedProducts);
        onClose();
    };

    handlePageChange = (page, size) => {
        const {
            addBulkItemsInPurchaseOrder: {
                filters,
            },
        } = this.props;
        this.fetchProducts(page, size, filters);
    };

    handleApplyFilter = (formValues) => {
        const { addBulkItemsInPurchaseOrder: { size } } = this.props;
        this.fetchProducts(PAGE, size, formValues);
    }

    render() {
        const {
            onClose,
            addBulkItemsInPurchaseOrder: {
                filters, page, size, totalElements,
            },
            autoDiscountConfig,
            usePurchaseDiscountInDisc1,
        } = this.props;
        const {
            schema,
            products,
            selectedProducts,
        } = this.state;
        return (
            <DialogComponent
                open
                handleClose={onClose}
                header="Add Bulk Items"
                maxWidth="xl"
                fullScreen
                fullWidth
            >
                <Grid container spacing={16} alignItems="center" >
                    <Grid item lg={6} md={6} sm={6}>
                        <GenericFilterWithSearch
                            filterSchema={ADD_BULK_ITEMS_FILTER_SCHEMA}
                            filterValues={filters}
                            saveFilter={this.handleApplyFilter}
                            placeholder="Search by name or code"
                        />
                    </Grid>
                    <Grid item sm={12} lg={12} md={12}>
                        {
                            schema && (
                                <AddBulkItemsTable
                                    uniqueKey="uuid"
                                    schema={schema}
                                    page={page}
                                    size={size}
                                    onPageChange={this.handlePageChange}
                                    data={products}
                                    totalElements={totalElements}
                                    onSelect={this.handleUpdateSelectedProduct}
                                    selectedProducts={selectedProducts}
                                    onRowClick={this.handleUpdateSelectedProduct}
                                    handleUpdateSelectedProduct={this.handleUpdateSelectedProduct}
                                    autoDiscountConfig={autoDiscountConfig}
                                    usePurchaseDiscountInDisc1={usePurchaseDiscountInDisc1}
                                />
                            )
                        }
                    </Grid>
                    <Grid item lg={16} md={16} sm={16} alignItems="center" justify="flex-end" container>
                        <ActionButton
                            className="ml-2"
                            test-id="purchaseorder-add-bulk-items-button"
                            primary
                            disableRipple
                            onClick={onClose}
                        >
                            Cancel
                        </ActionButton>
                        <ActionButton
                            className="ml-2"
                            test-id="purchaseorder-add-bulk-items-button"
                            primary
                            disableRipple
                            onClick={this.handleSave}
                        >
                            Save
                        </ActionButton>
                    </Grid>
                </Grid>
            </DialogComponent>
        );
    }
}

AddBulkItemsDialog.propTypes = {
    dispatch: PropTypes.func,
    warehouseId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    autoDiscountConfig: PropTypes.object,
    addBulkItemsInPurchaseOrder: PropTypes.object,
    usePurchaseDiscountInDisc1: PropTypes.bool,
};

AddBulkItemsDialog.defaultProps = {
    dispatch: () => {},
    warehouseId: null,
    autoDiscountConfig: {},
    addBulkItemsInPurchaseOrder: initialStates.addBulkItemsInPurchaseOrder,
    usePurchaseDiscountInDisc1: false,
};

const mapStateToProps = state => ({
    addBulkItemsInPurchaseOrder: state.addBulkItemsInPurchaseOrder,
});

export default connect(mapStateToProps)(AddBulkItemsDialog);
